//解析wms xml为leaflet tilelayer需要的参数
import axios from "axios"
import ogcParser from "ogc-parser"
export const resolveWMS = xmlUrl => axios({ method: 'get', url: xmlUrl }).then(res => {
    try {
        const capabilities = ogcParser.wms(res.data)
        return capabilities 
    } catch (err) {
        return { code: -1, message: 'xml解析失败', err }
    }
}).catch(err => {
    return err;
});